module.exports = __webpack_public_path__ + "img/icon-banner-dex-cloud.b96ab59e.svg";